import { render, staticRenderFns } from "./TransferenciaModal.vue?vue&type=template&id=1ea35414&scoped=true&"
import script from "./TransferenciaModal.vue?vue&type=script&lang=ts&"
export * from "./TransferenciaModal.vue?vue&type=script&lang=ts&"
import style0 from "./TransferenciaModal.vue?vue&type=style&index=0&id=1ea35414&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea35414",
  null
  
)

export default component.exports